import React from 'react'
import { BsInstagram, BsGithub, BsLinkedin  } from 'react-icons/bs'


const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
            <a href='https://www.linkedin.com/in/shivamsarang/' target='_blank' rel="noreferrer"><BsLinkedin /></a>
        </div>
        <div>
            <a href='https://github.com/ShivamSrng' target='_blank' rel="noreferrer"><BsGithub /></a>
        </div>
        <div>
            <a href='https://www.instagram.com/shivam_srng/' target='_blank' rel="noreferrer"><BsInstagram /></a>
        </div>
    </div>
  )
}

export default SocialMedia